import "./index.scss";

import { Box, Grid } from "@mui/material";
import SearchableList, { TSearchableItem } from "components/SearchableList";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface OptionSet {
  [key: string]: {
    id: string;
    label: string;
    options: TSearchableItem[];
  };
}

interface CategorisedNumberEntries {
  category_id: string;
  id: number;
}

const InterestsTab = (props: { interestsOptionsSets: OptionSet }) => {
  const { interestsOptionsSets } = props;
  const formContext = useFormContext();
  const { setValue, getValues } = formContext;
  const [selectedValues, setSelectedValues] = useState<CategorisedNumberEntries[]>([
    ...getValues("interests"),
  ]);

  //#region event handlers
  const handleUpdateInterests = (v: number[], categoryId) => {
    let interests: CategorisedNumberEntries[] = [...getValues("interests")];
    //Delete all entries following categoryId
    let indexesToDelete: number[] = [];
    interests.forEach((e, i) => {
      if (e.category_id === categoryId) indexesToDelete.push(i);
    });
    for (let i = indexesToDelete.length - 1; i >= 0; i--) {
      interests.splice(indexesToDelete[i], 1);
    }
    //Add the fresh batch of numbers
    v.forEach((e) => interests.push({ category_id: categoryId, id: e }));
    setValue("interests", [...interests]);
    //setSelectedValues([...interests]); // Was causing list to jump to top after selection
  };
  //#endregion event handlers

  const countSelectedItems = (key) => {
    return selectedValues.filter((val) => val.category_id === key).length;
  };

  return (
    <Grid container spacing={6} pr="10px" className="member-form-interests-tab">
      {interestsOptionsSets &&
        Object.keys(interestsOptionsSets).map((e, index) => {
          const preselectedValues = selectedValues
            ?.filter((f) => f.category_id === interestsOptionsSets[e].id)
            .map((m) => m.id);
          return (
            <Grid item xs={6} key={new Date().getTime() + `_${index}`}>
              <Box mb={`20px`}>
                <h2>{interestsOptionsSets[e].label}</h2>
              </Box>
              <SearchableList
                className="base-list"
                options={interestsOptionsSets[e].options}
                callback={(v) => handleUpdateInterests(v, interestsOptionsSets[e].id)}
                preselectedValues={preselectedValues}
              />
              {/* <span className="selectedGoalsSummary">{countSelectedItems(e)} items selected</span> */}
            </Grid>
          );
        })}
    </Grid>
  );
};

export default InterestsTab;
